/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBolt = createReactComponent("bolt", "IconBolt", [
  ["path", { d: "M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11", key: "svg-0" }]
]);

export { IconBolt as default };
//# sourceMappingURL=IconBolt.js.map
